import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApproveBankProofDocumentState, approveBankProofDocumentFeatureKey } from '../reducers/approve-bankproof-document.reducer';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import * as approvedState from '../reducers/approve-bankproof-document.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, ApproveBankProofDocumentState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee Approve SUB STATE
export const getApprovedState = createSelector(getMainEmployeeState, state => state[approveBankProofDocumentFeatureKey]);
//#endregion

//#region Employee Approve docs SUB STATE
export const selectApproveBankProofDocumentRequest = createSelector(getApprovedState, approvedState.getApproveBankProofDocumentRequest);
export const selectApproveBankProofDocumentSuccess = createSelector(getApprovedState, approvedState.getApproveBankProofDocumentResponse);
export const selectApproveBankProofDocumentFailure = createSelector(getApprovedState, approvedState.getApproveBankProofDocumentFailure);
//#endregion
